import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './Common/interceptor/interceptor-api';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { HashRouter } from 'react-router-dom';
import App from './App';

// Create a client
const queryClient = new QueryClient();

// Ensure the root element exists
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container missing');
}

// Create a root and render
const root = ReactDOMClient.createRoot(container);
root.render(
  <QueryClientProvider client={queryClient}>
    <HashRouter>
      <App />
    </HashRouter>
  </QueryClientProvider>,
);
